import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'External Sources',
      type: 'table',
      content: {
        '{}': {
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!system',
                },
              },
              filter: {
                '=': [
                  {
                    '@.': [
                      '!outcome',
                      {
                        ref: {
                          entity: {
                            '``': {
                              '@$': 'currentEntityId',
                            },
                          },
                        },
                      },
                    ],
                  },
                  {
                    '``': { '@$': 'currentRecordId' },
                  },
                ],
              },
              target: 'ent:!outcome_ext_sources:!source',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      url: {
                        '{}': {
                          value: {
                            '@.': '!url',
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      system: {
                        '{}': {
                          value: {
                            '@.': '!system',
                          },
                        },
                      },
                      description: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                    },
                  },
                  onClick: {
                    '{}': {
                      action: {
                        '{}': {
                          operation: 'ui.navigate',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  direct: {
                    '{}': {
                      name: 'Code',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'description',
                  direct: {
                    '{}': {
                      name: 'Description',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'url',
                  direct: {
                    '{}': {
                      name: 'URL',
                      type: 'URL',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'system',
                  direct: {
                    '{}': {
                      name: 'System',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
